"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlockableDeepLink = exports.UnlockableLongformAppInstall = exports.UnlockableLongformWebviewView = exports.UnlockableLongformVideoView = exports.UnlockableAttachmentImpression = exports.AttachmentType = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** Type of unlockable attachment */
var AttachmentType;
(function (AttachmentType) {
    AttachmentType[AttachmentType["UNKNOWN_ATTACHMENT_TYPE"] = 0] = "UNKNOWN_ATTACHMENT_TYPE";
    AttachmentType[AttachmentType["NO_ATTACHMENT"] = 1] = "NO_ATTACHMENT";
    AttachmentType[AttachmentType["LONGFORM_VIDEO"] = 2] = "LONGFORM_VIDEO";
    AttachmentType[AttachmentType["REMOTE_WEBVIEW"] = 3] = "REMOTE_WEBVIEW";
    AttachmentType[AttachmentType["APP_INSTALL"] = 4] = "APP_INSTALL";
    AttachmentType[AttachmentType["DEEP_LINK"] = 5] = "DEEP_LINK";
    AttachmentType[AttachmentType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AttachmentType = exports.AttachmentType || (exports.AttachmentType = {}));
function createBaseUnlockableAttachmentImpression() {
    return { typedTrackData: undefined };
}
exports.UnlockableAttachmentImpression = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.typedTrackData?.$case === "longformVideoImpression") {
            exports.UnlockableLongformVideoView.encode(message.typedTrackData.longformVideoImpression, writer.uint32(10).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "remoteWebpageImpression") {
            exports.UnlockableLongformWebviewView.encode(message.typedTrackData.remoteWebpageImpression, writer.uint32(18).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "appInstallImpression") {
            exports.UnlockableLongformAppInstall.encode(message.typedTrackData.appInstallImpression, writer.uint32(26).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "deepLinkImpression") {
            exports.UnlockableDeepLink.encode(message.typedTrackData.deepLinkImpression, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnlockableAttachmentImpression();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.typedTrackData = {
                        $case: "longformVideoImpression",
                        longformVideoImpression: exports.UnlockableLongformVideoView.decode(reader, reader.uint32()),
                    };
                    break;
                case 2:
                    message.typedTrackData = {
                        $case: "remoteWebpageImpression",
                        remoteWebpageImpression: exports.UnlockableLongformWebviewView.decode(reader, reader.uint32()),
                    };
                    break;
                case 3:
                    message.typedTrackData = {
                        $case: "appInstallImpression",
                        appInstallImpression: exports.UnlockableLongformAppInstall.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.typedTrackData = {
                        $case: "deepLinkImpression",
                        deepLinkImpression: exports.UnlockableDeepLink.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUnlockableAttachmentImpression();
        if (object.typedTrackData?.$case === "longformVideoImpression" &&
            object.typedTrackData?.longformVideoImpression !== undefined &&
            object.typedTrackData?.longformVideoImpression !== null) {
            message.typedTrackData = {
                $case: "longformVideoImpression",
                longformVideoImpression: exports.UnlockableLongformVideoView.fromPartial(object.typedTrackData.longformVideoImpression),
            };
        }
        if (object.typedTrackData?.$case === "remoteWebpageImpression" &&
            object.typedTrackData?.remoteWebpageImpression !== undefined &&
            object.typedTrackData?.remoteWebpageImpression !== null) {
            message.typedTrackData = {
                $case: "remoteWebpageImpression",
                remoteWebpageImpression: exports.UnlockableLongformWebviewView.fromPartial(object.typedTrackData.remoteWebpageImpression),
            };
        }
        if (object.typedTrackData?.$case === "appInstallImpression" &&
            object.typedTrackData?.appInstallImpression !== undefined &&
            object.typedTrackData?.appInstallImpression !== null) {
            message.typedTrackData = {
                $case: "appInstallImpression",
                appInstallImpression: exports.UnlockableLongformAppInstall.fromPartial(object.typedTrackData.appInstallImpression),
            };
        }
        if (object.typedTrackData?.$case === "deepLinkImpression" &&
            object.typedTrackData?.deepLinkImpression !== undefined &&
            object.typedTrackData?.deepLinkImpression !== null) {
            message.typedTrackData = {
                $case: "deepLinkImpression",
                deepLinkImpression: exports.UnlockableDeepLink.fromPartial(object.typedTrackData.deepLinkImpression),
            };
        }
        return message;
    },
};
function createBaseUnlockableLongformVideoView() {
    return {
        viewTimeSec: undefined,
        mediaDurationSec: undefined,
        renderedTimestampMs: undefined,
        openTimestampMs: undefined,
    };
}
exports.UnlockableLongformVideoView = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.viewTimeSec !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.viewTimeSec }, writer.uint32(10).fork()).ldelim();
        }
        if (message.mediaDurationSec !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.mediaDurationSec }, writer.uint32(18).fork()).ldelim();
        }
        if (message.renderedTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.renderedTimestampMs }, writer.uint32(26).fork()).ldelim();
        }
        if (message.openTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.openTimestampMs }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnlockableLongformVideoView();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.viewTimeSec = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.mediaDurationSec = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.renderedTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.openTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUnlockableLongformVideoView();
        message.viewTimeSec = object.viewTimeSec ?? undefined;
        message.mediaDurationSec = object.mediaDurationSec ?? undefined;
        message.renderedTimestampMs = object.renderedTimestampMs ?? undefined;
        message.openTimestampMs = object.openTimestampMs ?? undefined;
        return message;
    },
};
function createBaseUnlockableLongformWebviewView() {
    return {
        viewTimeSec: undefined,
        renderedTimestampMs: undefined,
        loadedOnEntry: undefined,
        loadedOnExit: undefined,
        openTimestampMs: undefined,
        pixelCookieSet: undefined,
    };
}
exports.UnlockableLongformWebviewView = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.viewTimeSec !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.viewTimeSec }, writer.uint32(10).fork()).ldelim();
        }
        if (message.renderedTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.renderedTimestampMs }, writer.uint32(18).fork()).ldelim();
        }
        if (message.loadedOnEntry !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.loadedOnEntry }, writer.uint32(26).fork()).ldelim();
        }
        if (message.loadedOnExit !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.loadedOnExit }, writer.uint32(34).fork()).ldelim();
        }
        if (message.openTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.openTimestampMs }, writer.uint32(42).fork()).ldelim();
        }
        if (message.pixelCookieSet !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.pixelCookieSet }, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnlockableLongformWebviewView();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.viewTimeSec = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.renderedTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.loadedOnEntry = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.loadedOnExit = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.openTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.pixelCookieSet = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUnlockableLongformWebviewView();
        message.viewTimeSec = object.viewTimeSec ?? undefined;
        message.renderedTimestampMs = object.renderedTimestampMs ?? undefined;
        message.loadedOnEntry = object.loadedOnEntry ?? undefined;
        message.loadedOnExit = object.loadedOnExit ?? undefined;
        message.openTimestampMs = object.openTimestampMs ?? undefined;
        message.pixelCookieSet = object.pixelCookieSet ?? undefined;
        return message;
    },
};
function createBaseUnlockableLongformAppInstall() {
    return {
        openTimestampMs: undefined,
        loadedOnEntry: undefined,
        loadedOnExit: undefined,
        visibleLoadTimeMs: undefined,
    };
}
exports.UnlockableLongformAppInstall = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.openTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.openTimestampMs }, writer.uint32(10).fork()).ldelim();
        }
        if (message.loadedOnEntry !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.loadedOnEntry }, writer.uint32(18).fork()).ldelim();
        }
        if (message.loadedOnExit !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.loadedOnExit }, writer.uint32(26).fork()).ldelim();
        }
        if (message.visibleLoadTimeMs !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.visibleLoadTimeMs }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnlockableLongformAppInstall();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.openTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.loadedOnEntry = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.loadedOnExit = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.visibleLoadTimeMs = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUnlockableLongformAppInstall();
        message.openTimestampMs = object.openTimestampMs ?? undefined;
        message.loadedOnEntry = object.loadedOnEntry ?? undefined;
        message.loadedOnExit = object.loadedOnExit ?? undefined;
        message.visibleLoadTimeMs = object.visibleLoadTimeMs ?? undefined;
        return message;
    },
};
function createBaseUnlockableDeepLink() {
    return {
        openTimestampMs: undefined,
        redirectToStore: undefined,
        redirectToWebview: undefined,
    };
}
exports.UnlockableDeepLink = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.openTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.openTimestampMs }, writer.uint32(10).fork()).ldelim();
        }
        if (message.redirectToStore !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.redirectToStore }, writer.uint32(18).fork()).ldelim();
        }
        if (message.redirectToWebview !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.redirectToWebview }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnlockableDeepLink();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.openTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.redirectToStore = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.redirectToWebview = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUnlockableDeepLink();
        message.openTimestampMs = object.openTimestampMs ?? undefined;
        message.redirectToStore = object.redirectToStore ?? undefined;
        message.redirectToWebview = object.redirectToWebview ?? undefined;
        return message;
    },
};
//# sourceMappingURL=unlockable_attachment_impression.js.map